import { queryOptions } from '@tanstack/react-query';
import { api, apiMutation, mutation } from '../../../api/http';

export interface TagResponse {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  archivedAt: string | null;
  usageCount: number;
  version: number;
}

export const tagQueryKeys = {
  list: ['internal', 'tags'] as const,
};

export const tagListQuery = queryOptions({
  queryKey: tagQueryKeys.list,
  queryFn: ({ signal }) => api<TagResponse[]>('/internal/tags', { signal }),
});

export function createTag(name: string, description: string | null = null) {
  return mutation<TagResponse>('/internal/tags', { name, description });
}

export function saveTag(id: string, name: string, description: string | null) {
  return apiMutation<TagResponse>(`/internal/tags/${id}`, 'PUT', { name, description });
}

export function archiveTag(id: string, archived: boolean) {
  return mutation<TagResponse>(`/internal/tags/${id}/${archived ? 'archive' : 'unarchive'}`, {});
}

export function deleteTag(id: string) {
  return apiMutation<void>(`/internal/tags/${id}`, 'DELETE');
}

export function mergeTag(sourceId: string, targetId: string, expectedVersion: number) {
  return apiMutation<TagResponse>(`/internal/tags/${sourceId}/merge`, 'POST', {
    targetId,
    expectedVersion,
  });
}
